import { RoutineFilterModel } from '@gripp/shared-logic';

export const buildRoutinesListFilter = (
  routineFilter: RoutineFilterModel | undefined,
  impersonatingWorkspaceId?: string
) => {
  const filter = routineFilter
    ? new RoutineFilterModel(routineFilter)
    : new RoutineFilterModel();
  filter.workspaceId = impersonatingWorkspaceId;
  return filter.getGraphQLFilter();
};
